import { useEffect, useState } from 'react';

export default function useBlockExistence(anchorElements, rootId = 'epi-page-container') {
  const [existingBlocks, setExistingBlocks] = useState({});

  useEffect(() => {
    const root = document.getElementById(rootId);
    if (!root) return;

    const update = () => {
        const map = {};
      
        anchorElements.forEach(anchor => {
          const el = document.getElementById(`block-${anchor.linked_block}`);
      
          if (!el) {
            map[anchor.linked_block] = false;
            return;
          }
      
          // Check for meaningful content
          const hasElementChild = el.tagName === 'SPAN'
          ? el.nextElementSibling?.children.length > 0
          : el.children.length > 0;
          const hasTextContent = el.textContent?.trim().length > 0;
      
          map[anchor.linked_block] = hasElementChild || hasTextContent;
        });
      
        setExistingBlocks(map);
      };

    update(); // initial check

    const observer = new MutationObserver(update);
    observer.observe(root, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [anchorElements, rootId]);

  return existingBlocks;
}
